import { render, staticRenderFns } from "./health-sidebar.vue?vue&type=template&id=1e5ec33e&scoped=true"
import script from "./health-sidebar.vue?vue&type=script&lang=js"
export * from "./health-sidebar.vue?vue&type=script&lang=js"
import style0 from "./health-sidebar.vue?vue&type=style&index=0&id=1e5ec33e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5ec33e",
  null
  
)

export default component.exports